import React from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";

const ErrorMessage = function ({ heading, children }) {
  return (
    <div className="m-feedbackBox -theme-red">
      <div className="m-feedbackBox__icon-heading">
        <span className="a-icon -large -red">
          <span className="fa-stack fa-2x">
            <i className="fa fa-circle fa-stack-2x fa-inverse" />
            <i className="fa fa-exclamation fa-stack-1x" />
          </span>
        </span>
        <h3 className="m-feedbackBox__heading">{heading}</h3>
      </div>
      <div>{ReactHtmlParser(children)}</div>
    </div>
  );
};

ErrorMessage.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

export default ErrorMessage;
